import * as z from "zod/v4";

export const disconnectFaireIntegration = {
  name: "disconnectFaireIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
